import { makeStyles } from '@material-ui/core/styles'
import { ALIGN, FLEX } from '@v4/constants/quiz'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'relative',
			height: '100%',
			width: '100%',
		},

		image: {
			width: '100%',
			height: '100%',

			'& img': {
				width: '100%',
				height: '100%',
				objectFit: ({ objectFit }) => objectFit || 'contain',
				objectPosition: ({ align }) => {
					const isRtl = theme.direction === 'rtl'
					const alignValue = isRtl ? ALIGN.RIGHT : ALIGN.LEFT
					const position = align === FLEX.START ? alignValue : align

					return `${position} center`
				},
			},
		},
	}),
	{ name: 'Media' },
)

export default useStyles
